import { Component, ViewChild } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthUser, Utente } from '../../../../shared/interface';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';
import { StorageService } from '../../../../services/storage.service';
import { PASSWORD_HINT, passwordMatchValidator, strongPasswordValidator } from '../../../../shared/password.validators';

@Component({
  selector: 'app-modifica-utente-backoffice',
  templateUrl: './modifica-utente-backoffice.component.html',
  styleUrl: './modifica-utente-backoffice.component.css'
})
export class ModificaUtenteBackofficeComponent {

  constructor(private apiService: ApiService, private storageService: StorageService, private router: Router, private route: ActivatedRoute, private confirmationService: ConfirmationService) { }

  @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;

  formUtente!: FormGroup;
  passwordHint = PASSWORD_HINT;

  tipi: { tipo: string }[] = [
    { tipo: 'Operatore' },
    { tipo: 'Amministratore' }
  ]

  utente?: Utente;
  user?: AuthUser | null;

  ngOnInit(): void {

    this.user = this.storageService.getUser();

    this.formUtente = new FormGroup({
      username: new FormControl(null, Validators.required),
      email: new FormControl(null, Validators.email),
      password: new FormControl(null, [strongPasswordValidator('username')]),
      confirm_password: new FormControl(null),
      tipo: new FormControl(null, Validators.required)
    }, { validators: passwordMatchValidator() });

    this.route.params.subscribe(params => {
      const id = params['id'];

      this.apiService.getUtente(id).subscribe({
        next: (data) => this.utente = data,
        error: () => this.router.navigate(['/backoffice/utenti']),
        complete: () => {
          this.formUtente.patchValue({
            username: this.utente?.username,
            email: this.utente?.email,
            tipo: { tipo: this.utente?.tipo }
          })
        }
      })
    })
  }

  onDeletePopup(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare l'utente?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteUtente(this.utente!.id).subscribe({
          next: () => this.apiService.setUtenti(),
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            if (this.user?.id == this.utente?.id) {
              this.storageService.clearStorage()
              this.router.navigate(['/backoffice/login']);
            } else {
              this.router.navigate(['/backoffice/utenti']);
            }
            this.confirmationService.close()
            this.apiService.message("success", "Eliminazione", "L'utente è stato eliminato con successo")
          }
        })
      }
    });
  }

  onDelete() {
    this.confirmPopup.accept();
  }

  onAnnulla() {
    this.confirmPopup.reject();
  }

  onSubmit() {

    let utente = {
      username: this.formUtente.get('username')?.value,
      email: this.formUtente.get('email')?.value || '',
      tipo: this.formUtente.get('tipo')?.value.tipo
    }

    let password = {
      password: this.formUtente.get('password')?.value || '',
    }

    this.apiService.updateUtente(utente, this.utente!.id).subscribe({
      next: () => this.apiService.setUtenti(),
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {

        if (password.password.length > 0) {

          this.apiService.updatePasswordUtente(password, this.utente!.id).subscribe({
            next: () => this.apiService.setUtenti(),
            error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
            complete: () => {
              this.router.navigate(['/backoffice/utenti'])
              this.apiService.message('success', 'Modifica', "Modifica effettuata con successo!")
            }
          })

        } else {
          this.router.navigate(['/backoffice/utenti'])
          this.apiService.message('success', 'Modifica', "Modifica effettuata con successo!")
        }
      }
    })
  }

}
